<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">{{ this.pageName }}</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item">CMS</li>
                            <li class="breadcrumb-item active">{{ this.pageName }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ this.pageName }}</h4>
                </div>

                <div class="card-body">
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allConfigurations"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'value'">
                                <template v-if="props.row.type === configurationEnums.IMAGE">
                                    <a :href="props.row.image" target="_blank">
                                       <img :src="props.row.image" :alt="props.row.name +' Image'"
                                            class="img-thumbnail img-fluid"
                                            style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                                    </a>
                                </template>
                                <template v-else-if="props.row.type === configurationEnums.FILE">
                                    <a :href="props.row.value" target="_blank">
                                        View File
                                    </a>
                                </template>

                                <template v-else>
                                    {{ props.row.value }}
                                </template>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <a href="#"
                                   class="dropdown-item"
                                   @click.prevent="updateConfigurationModal"
                                   :data-key="props.row.key"
                                   :data-status="props.row.status"
                                   :data-allow-status-update="props.row.allow_status_update"
                                   :data-value="props.row.value"
                                   :data-type="props.row.type"
                                   :data-id="props.row.id"
                                   :data-psa-background-colour="props.row.psa_background_colour"
                                   data-toggle="modal"
                                   data-target="#faq-modal">
                                    <i class="feather icon-edit"></i>
                                    Update
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>

            <div class="modal fade update-configuration-modal" tabindex="-1" role="dialog"
                 aria-labelledby="myLargeModalLabel"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <form @submit.prevent="updateConfiguration">
                            <div class="modal-header"><h4 id="myModalLabel1" class="modal-title">Edit Configuration</h4>
                                <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span
                                    aria-hidden="true">×</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="form-group">
                                    <label class="form-label">Configuration Key</label>
                                    <input type="text" required="required" readonly v-model="configuration.key"
                                           class="form-control">
                                    <span v-if="configuration.errors.key"
                                          class="text-danger text-small">{{ configuration.errors.key }}</span>
                                </div>

                                <div class="form-group">
                                    <label>Configuration Value</label>

                                    <template v-if="configuration.type===this.configurationEnums.LONGTEXT">
                                        <textarea v-model="configuration.value" id="editor" cols="30" rows="10"
                                                  class="form-control"></textarea>
                                        <!--                                        <quill-editor v-model="configuration.value" />-->
                                    </template>

                                    <template v-if="configuration.type===this.configurationEnums.NUMBER">
                                        <input type="number" required v-model="configuration.value"
                                               class="form-control">
                                    </template>

                                    <template v-if="configuration.type===this.configurationEnums.BOOL">
                                        <select name="" v-model="configuration.value" class="form-control">
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </select>
                                    </template>

                                    <template v-if="configuration.type===this.configurationEnums.TEXT && configuration.key==='psa_announcement'">
                                        <input type="text" required v-model="configuration.value" class="form-control" maxlength="100">
                                    </template>

                                    <template v-if="configuration.type===this.configurationEnums.TEXT && configuration.key!=='psa_announcement'">
                                        <input type="text" required v-model="configuration.value" class="form-control">
                                    </template>

                                    <template
                                        v-if="configuration.type===this.configurationEnums.IMAGE || configuration.type===this.configurationEnums.FILE">
                                        <!--                                        <input type="file" required-->
                                        <!--                                               @input="configuration.value = $event.target.files[0]"-->
                                        <!--                                               class="form-control">-->
                                        <div class="row">
                                            <div class="col-3">
                                                <a :href="configuration.value" target="_blank">
                                                    <img :src="configuration.value"
                                                         :alt="configuration.key +' Image'"
                                                         class="img-thumbnail img-fluid"
                                                         style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                                                </a>
                                            </div>
                                        </div>
                                        <button type="button" data-toggle="modal" data-target="#gallery-modal"
                                                class="form-control">Update Image
                                        </button>
                                    </template>
                                    <span v-if="configuration.errors.key"
                                          class="text-danger text-small">{{ configuration.errors.key }}</span>
                                </div>

                                <div v-if="configuration.key === 'psa_announcement'" class="form-group">
                                    <label class="form-label">PSA Background colour</label>
                                    <input type="color" required="required" v-model="configuration.psa_background_colour"
                                           class="form-control">
                                    <span v-if="configuration.errors.psa_background_colour"
                                          class="text-danger text-small">{{ configuration.errors.psa_background_colour }}</span>
                                </div>
                                <template v-if="configuration.allow_status_update">
                                    <div class="form-check">
                                        <input type="checkbox" v-model="configuration.status" class="form-check-input"
                                               id="statusCheck">
                                        <label for="statusCheck" class="form-check-label">Activate this
                                            configuration?</label>
                                        <span v-if="configuration.errors.status"
                                              class="text-danger text-small">{{ configuration.errors.status }}</span>
                                    </div>
                                </template>

                            </div>

                            <div class="modal-footer">
                                <button class="btn btn-primary" :disabled="saving">
                                    Save <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <gallery-modal @chooseImage="chosenImage" gallery-header="Select Image"></gallery-modal>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import QuillEditor from '../../Shared/QuillEditor';
import GalleryModal from "@/Shared/GalleryModal";

export default {
    metaInfo: {title: 'Configurations'},
    props: [
        'configurations',
        'configurationEnums',
        'pageName',
        'routeName',
    ],
    layout: Layout,
    name: 'ConfigurationIndex',
    components: {
        Link,
        QuillEditor,
        GalleryModal,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data() {
        return {
            baseUrl: window.location.origin,
            saving: false,
            configuration: this.$inertia.form({
                key: null,
                value: null,
                id: null,
                type: null,
                status: null,
                allow_status_update: null,
                psa_background_colour: null
            }),
            filters: {},
            isLoadingFilter: false,
            allConfigurations: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10,
                columnFilters: {},
            },
            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },
            sortingOptions: {
                enabled: false,
            },
            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Name', field: 'description', thClass: 'text-center', tdClass: 'text-center',},
                {label: 'Value', field: 'value', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Action', field: 'action', sortable: false},
            ],
            tableDataLoading: false,
        };
    },
    mounted() {
        this.allConfigurations = this.configurations.data;
        this.totalRecords = this.configurations.total;
    },

    methods: {
        chosenImage(image) {
            this.configuration.value = image.image;
        },

        updateConfigurationModal(event) {
            this.configuration.key = event.target.getAttribute('data-key')
            this.configuration.value = event.target.getAttribute('data-value')
            this.configuration.type = event.target.getAttribute('data-type')
            this.configuration.id = event.target.getAttribute('data-id')
            this.configuration.status = event.target.getAttribute('data-status') === '1';
            this.configuration.allow_status_update = event.target.getAttribute('data-allow-status-update') === '1';
            this.configuration.psa_background_colour = event.target.getAttribute('data-psa-background-colour')
            $('.update-configuration-modal').modal('show');
        },

        async paginatedData() {
            try {
                let routeName = this.routeName;

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allConfigurations = response.data.data
            } catch (e) {
                console.log(e);
            }
        },

        async updateConfiguration(id = null) {
            this.saving = true;
            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                    $('.update-configuration-modal').modal('hide');
                },
                onError: () => {
                    this.saving = false;
                }
            };

            this.configuration.post(route('admin.configurations.update', this.configuration.id), options);
            this.saving = false;

            await this.paginatedData();
        },
    }
}
</script>
